import React from "react";
import { Card, Image, Spinner, Placeholder } from "react-bootstrap";
import Rejeced from "../../../../assets/img/rejected.png";
import ApprovedImage from "../../../../assets/img/approved.png";
import PendingImage from "../../../../assets/img/time-management.png";
import Approve from "../../../../assets/img/approve.png";
import { useGetCompanyPropertyDetailsQuery } from "../../lib/apiSlice/property/propertySlice.tsx";

export default function MetricCard({ Total, Approved, Rejected, Pending }) {
    const { data, isLoading } = useGetCompanyPropertyDetailsQuery();
    const companyDetails = data?.results?.[0] || {};

    return (
        <div className="staticCards d-flex justify-content-start mt-5">
            <Card className="w-25 rentDue">
                <Card.Body>
                    <Image src={ApprovedImage} />
                    <div className="float-left">
                        <span>Total Approvals</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p>{Approved} Approvals(s)</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 defaulters">
                <Card.Body>
                    <Image src={PendingImage} />
                    <div className="float-left">
                        <span className="defaultersText">Pending Approvals</span>
                        {isLoading ? (
                            <Placeholder as="p" animation="glow">
                                <Placeholder xs={6} />
                            </Placeholder>
                        ) : (
                            <p className="defaultersText">{Pending} Approvals</p>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 income">
                <Card.Body>
                    <Image src={Rejeced} />
                    <div className="float-left">
                        <span>Rejected Approvals</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="defaultersText">{Rejected}  Approvals</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 occupacy">
                <Card.Body>
                    <Image src={Approve} />
                    <div className="float-left">
                        <span>Total Approved</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="defaultersText">{Total} Approvals</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}